class CollapsibleTab extends HTMLElement {
  connectedCallback() {
    this.contentHeight = 0;
    this.content = this.querySelector('[data-collapsible-content]');
    if(!this.content) {
      throw new Error('Collapsible tab requires a content element.');
    }
    this.trigger = this.querySelector('[data-collapsible-trigger]');
    if(!this.trigger) {
      throw new Error('Collapsible tab requires a trigger element.');
    }
    this.calcHeight();
    this.trigger.addEventListener('click', this.toggle.bind(this));
    window.addEventListener('resize', this.calcHeight.bind(this));
  }

  setVisibility() {
    if(this.querySelector('.content-grid').children.length === 0) {
      this.style.opacity = 0;
      setTimeout(() => {
        this.style.display = 'none';
      }, 150)
      return false;
    }
    else {
      this.style.display = 'block';
      setTimeout(() => {
        this.style.opacity = 1;
      }, 100)
    }
    return true;
  }

  calcHeight() {
    if(!this.setVisibility()) return;
    this.contentHeight = calcHeight(this.content, this);
    this.content.style.setProperty('--content-height', `${this.contentHeight}px`);
  }

  toggle() {
    this.dataset.state === 'active' ? this.close() : this.open();
  }

  open() {
    this.calcHeight();
    this.setAttribute('data-state', 'active');
  }

  close() {
    this.setAttribute('data-state', 'inactive');
  }
}

customElements.define('collapsible-tab', CollapsibleTab);